import { api } from '@services';

import Studio, { IStudio, IStudioApiModel } from '@models/Studio.model';

const getStudios = async (): Promise<IStudio[]> => {
  const { data: studios } = await api.get<IStudioApiModel[]>('/studios');

  return Studio.arrayFromApiModel(studios);
};

export { getStudios };
